import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import RTLLayout from './layouts/rtl';
import { ChakraProvider } from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext'; // import AuthProvider

// Optional: PrivateRoute component to protect admin routes
const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) return null; // or a loader while checking auth
  return currentUser ? children : <Navigate to="/auth" replace />;
};

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  return (
    <ChakraProvider theme={currentTheme}>
      <AuthProvider>
        <Routes>
          {/* Auth routes */}
          <Route path="auth/*" element={<AuthLayout />} />

          {/* Admin routes protected by auth */}
          <Route
            path="admin/*"
            element={
              <PrivateRoute>
                <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
              </PrivateRoute>
            }
          />

          {/* RTL routes */}
          {/* <Route
            path="rtl/*"
            element={<RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />}
          /> */}

          {/* Default landing page */}
          <Route path="/" element={<Navigate to="/auth" replace />} />
        </Routes>
      </AuthProvider>
    </ChakraProvider>
  );
}
